const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://ninhthuan-api.cgis.asia/",
  },
  production: {
      api: "https://ninhthuan-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
